module.exports = __webpack_public_path__ + "static/media/nextagramvid.68a88466.mov";